// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0761ce25","453":"82a28197","455":"18ed2383"}[chunkId] + ".chunk.js";
};